import { MessageSquare, Phone, Zap } from "lucide-react";
import { ChannelConfig, Reseller1 } from "../../components/types";

  export const resellers: Reseller1[] = [
    {
      id: "RES001",
      name: "TechCorp Solutions",
      rates: {
        sms: { transactional: 0.045, promotional: 0.038 },
        whatsapp: {
          marketing: 0.12,
          authentication: 0.089,
          utility: 0.095,
          service: 0.076,
        },
        rcs: { standard: 0.067 },
      },
    },
    {
      id: "RES002",
      name: "Digital Marketing Pro",
      rates: {
        sms: { transactional: 0.052, promotional: 0.041 },
        whatsapp: {
          marketing: 0.135,
          authentication: 0.098,
          utility: 0.104,
          service: 0.082,
        },
        rcs: { standard: 0.073 },
      },
    },
    {
      id: "RES003",
      name: "Cloud Communications Ltd",
      rates: {
        sms: { transactional: 0.038, promotional: 0.032 },
        whatsapp: {
          marketing: 0.115,
          authentication: 0.081,
          utility: 0.087,
          service: 0.069,
        },
        rcs: { standard: 0.059 },
      },
    },
  ];

  // Channel configurations
  export const channelConfig: Record<"sms" | "whatsapp" | "rcs", ChannelConfig> = {
    sms: {
      name: "SMS",
      icon: MessageSquare,
      color: "blue",
      categories: [
        {
          value: "transactional",
          label: "Transactional",
          description: "OTP, alerts, confirmations",
        },
        {
          value: "promotional",
          label: "Promotional",
          description: "Marketing campaigns, offers",
        },
      ],
    },
    whatsapp: {
      name: "WhatsApp",
      icon: Phone,
      color: "green",
      categories: [
        {
          value: "marketing",
          label: "Marketing",
          description: "Promotional content, campaigns",
        },
        {
          value: "authentication",
          label: "Authentication",
          description: "OTP, verification codes",
        },
        {
          value: "utility",
          label: "Utility",
          description: "Account updates, reminders",
        },
        {
          value: "service",
          label: "Service",
          description: "Customer support, inquiries",
        },
      ],
    },
    rcs: {
      name: "RCS",
      icon: Zap,
      color: "purple",
      categories: [
        {
          value: "standard",
          label: "Standard",
          description: "Rich messaging content",
        },
      ],
    },
  };